import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import resume from "../assets/pdf/resume.pdf";

const ResumeModal = ({ className, onClick }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button
        variant="link"
        onClick={() => {
          handleShow();
          onClick();
        }}
        className={className}
      >
        Experience
      </Button>

      <Modal show={show} onHide={handleClose} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title>My Resume</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              position: "relative",
              height: "0",
              paddingBottom: "56.25%",
            }}
          >
            <iframe
              src={resume}
              style={{
                border: "none",
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
              }}
              title="Resume"
            ></iframe>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ResumeModal;
